






















































































































import * as dayjs from 'dayjs'
import {apiV1AdminApplicantPath, apiV1AdminApplicantsPath} from '@/rails/routes'
import axios from 'axios'
import {Component, Emit, Prop, Watch} from 'vue-property-decorator'
import VueBase from '@/pages/vue-base'
import { DataTableHeader } from 'vuetify'
import ListCount from '@/components/admin/ListCount.vue'
import Applicant from "@/models/Applicant"
import Recruit from "@/models/Recruit"
import ApplicantForm from "@/components/admin/applicants/Form.vue"
import FormBase from "@/pages/form-base"
import {saveAs} from "file-saver"

@Component({
  components: {
    ListCount,
    ApplicantForm
  }
})
export default class ApplicantList extends VueBase {
  @Prop(Array) readonly applicants!: Array<Applicant>
  get recruits(): Array<Recruit> {
    const recruits: Array<Recruit> = []
    this.applicants.forEach(applicant => {
      if (!recruits.find(recruit => recruit.id === applicant.recruit.id)) {
        recruits.push(applicant.recruit)
      }
    })
    return recruits
  }

  get years(): Array<number> {
    return [2021, 2020, 2019]
  }

  get results(): Array<string> {
    const results: Array<string> = []
    this.applicants.forEach(applicant => {
      if (applicant.result && !results.find(result => result === applicant.result)) {
        results.push(applicant.result)
      }
    })
    return results
  }

  @Emit()
  onSave(): void {}

  @Watch('applicants')
  sort(): Array<Applicant> {
    return this.applicants.concat().sort((a, b) => {
      if(a.closed > b.closed) return 1;
      if(a.closed < b.closed) return -1;
      if (this.sortBy && this.sortBy.length) {
        const sortDesc = Array.isArray(this.sortDesc) ? this.sortDesc[0] : this.sortDesc
        if(this.digValue(a, this.sortBy) > this.digValue(b, this.sortBy)) return sortDesc ? -1 : 1;
        if(this.digValue(a, this.sortBy) < this.digValue(b, this.sortBy)) return sortDesc ? 1 : -1;
      }
      return 0;
    })
  }

  digValue(obj: Applicant, key: string | Array<string>): any {
    let value = obj;
    (Array.isArray(key) ? key[0] : String(key)).split('.').forEach(k => {
      value = value[k]
    })
    return value;
  }

  headers: Array<DataTableHeader> = [
    { text: '', value: 'actions', sortable: false, width: 40 },
    { text: '登録者', value: 'user.name', width: 100 },
    { text: '年齢', value: 'user.age', width: 80 },
    { text: '性別', value: 'user.gender_text', width: 80 },
    { text: 'UIターン', value: 'user.ui_turn_result', width: 100 },
    { text: '職種', value: 'user.hope_job_text', width: 80 },
    { text: '企業', value: 'recruit.title', width: 100 },
    { text: '結果', value: 'result', width: 100 },
    { text: '年度', value: 'years', width: 100, align: 'center' },
    { text: '応募', value: 'applied_on', width: 100, align: 'center' },
    { text: '企業推薦', value: 'recommended_on', width: 100, align: 'center' },
    { text: '面接', value: 'interviewed_on', width: 100, align: 'center' },
    { text: '内定', value: 'offered_on', width: 100, align: 'center' },
    { text: '内定承諾', value: 'accepted_on', width: 100, align: 'center' },
    { text: '備考', value: 'memo', width: 100 },
  ]
  keyword = ''
  status: string = ''
  recruit_id: number = null
  year: number = null
  result: string = ''
  edit = new Applicant()
  showedEditApplicant = false
  editApplicant = new Applicant()
  sortBy = ''
  sortDesc = true

  get viewApplicants(): Array<Applicant> {
    let applicants = this.applicants
    if (this.keyword) {
      const keyword = this.keyword.toLocaleLowerCase()
      applicants = applicants.filter(
        applicant => applicant.memo?.toLocaleLowerCase()?.includes(keyword) ||
          applicant.user.name?.toLocaleLowerCase()?.includes(keyword) ||
          applicant.recruit.title.toLocaleLowerCase().includes(keyword)
      )
    }
    if (this.recruit_id) {
      applicants = applicants.filter(
        applicant => applicant.recruit_id === this.recruit_id
      )
    }
    if (this.year) {
      applicants = applicants.filter(
        applicant => applicant.years === this.year
      )
    }
    if (this.result) {
      applicants = applicants.filter(
        applicant => applicant.result === this.result
      )
    }
    return applicants
  }

  get resultItems(): Array<string> {
    return this.applicants.map(a => a.result).filter(r => !!r)
  }

  startEdit(applicant: Applicant): void {
    this.editApplicant = new Applicant({
      id: applicant.id,
      user_id: applicant.user_id,
      recruit_id: applicant.recruit_id,
      years: applicant.years,
      closed: applicant.closed,
      result: applicant.result,
      memo: applicant.memo,
      applied_on: applicant.applied_on ? dayjs(applicant.applied_on).format('YYYY-MM-DD') : undefined,
      recommended_on: applicant.recommended_on ? dayjs(applicant.recommended_on).format('YYYY-MM-DD') : undefined,
      interviewed_on: applicant.interviewed_on ? dayjs(applicant.interviewed_on).format('YYYY-MM-DD') : undefined,
      offered_on: applicant.offered_on ? dayjs(applicant.offered_on).format('YYYY-MM-DD') : undefined,
      accepted_on: applicant.accepted_on ? dayjs(applicant.accepted_on).format('YYYY-MM-DD') : undefined,
      recommended: applicant.recommended,
      interviewed: applicant.interviewed,
      offered: applicant.offered,
      accepted: applicant.accepted,
      created_by: applicant.created_by,
    })
    this.showedEditApplicant = true
  }

  async save(): Promise<void> {
    if (!(this.$refs.applicantForm as FormBase).validate()) {
      this.showError('入力内容に不備があります。確認してください。')
      return
    }

    (document.activeElement as HTMLInputElement)?.blur()
    this.$nextTick(async () => {
      try {
        if (this.editApplicant.id) {
          await axios.put(apiV1AdminApplicantPath(this.editApplicant.id), {
            applicant: this.editApplicant.toParams()
          })
        } else {
          await axios.post(apiV1AdminApplicantsPath(), {
            applicant: this.editApplicant.toParams()
          })
        }
        this.showMessage('変更を保存しました。')
        this.editApplicant = new Applicant()
        this.showedEditApplicant = false
        this.onSave()
      } catch (e) {
        console.log(e)
      }
    })
  }

  async download(): Promise<void> {
    this.showLoading()
    const res = await axios.get(apiV1AdminApplicantsPath({ format: 'xlsx' }), {
      responseType: 'blob'
    })
    const blob = new Blob([res.data], )
    saveAs(blob, `applicants_${dayjs().format('YYYYMMDD_HHmm')}.xlsx`)
    this.hideLoading()
  }
}
